import { gql } from '@apollo/client';
import { imageCardFragment } from '@src/components/ImageCard/ImageCard.fragment';

export const imageCardBlockFragment = gql`
  fragment imageCardBlock on ImageCardBlock {
    __typename
    sys {
      ...sys
    }
    tagline
    layout
    showSunray
    mainHeading: heading {
      ...imageCardBlockHeadingRT
    }
    bodyContent {
      ...imageCardBlockBodyContentRT
    }
    primaryCta {
      ...cta
    }
    secondaryCta {
      ...cta
    }
    imageCardItemsCollection(limit: 4) {
      items {
        ...imageCard
      }
    }
  }

  fragment imageCardBlockHeadingRT on ImageCardBlockHeading {
    json
    links {
      ...imageCardBlockHeadingRTLinks
    }
  }

  fragment imageCardBlockHeadingRTLinks on ImageCardBlockHeadingLinks {
    entries {
      block {
        sys {
          ...sys
        }
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }

  fragment imageCardBlockBodyContentRT on ImageCardBlockBodyContent {
    json
    links {
      ...imageCardBlockBodyContentRTLinks
    }
  }

  fragment imageCardBlockBodyContentRTLinks on ImageCardBlockBodyContentLinks {
    entries {
      block {
        sys {
          ...sys
        }
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }

  ${imageCardFragment}
`;
